(function ($) {
    var sportdataStatsFilterClass = {};
    sportdataStatsFilterClass.run = function (filterInstance) {
        // private variables
        var thisStatsFilter = $(filterInstance);
        if (!$(thisStatsFilter).hasClass("sportdata-stats-filter")) {
            thisStatsFilter = $(filterInstance).closest(".sportdata-stats-filter");
        }

        // private methods
        var submit = function () {
            var currentURL = location.protocol + '//' + location.host + location.pathname;
            var pathName = location.pathname;
            var newParams = [];
            var newQuery = [];

            var c = thisStatsFilter.find('[name=periodo]').first();
            if (c.length === 1 && c.val().trim().length > 0) {
                newQuery.push("periodo=" + encodeURIComponent(c.val()));
                if (c.val() === 'range-date') {
                    c = thisStatsFilter.find('[name=data_inizio]').first();
                    if (c.length === 1 && c.val().trim().length > 0) {
                        newQuery.push("data_inizio=" + encodeURIComponent(c.val()));
                    }
                    c = thisStatsFilter.find('[name=data_fine]').first();
                    if (c.length === 1 && c.val().trim().length > 0) {
                        newQuery.push("data_fine=" + encodeURIComponent(c.val()));
                    }
                }
            }
            c = thisStatsFilter.find('[name=eta]').first();
            if (c.length === 1 && c.val().trim().length > 0) {
                newQuery.push("eta=" + encodeURIComponent(c.val()));
            }
            c = thisStatsFilter.find('[name=ippodromo]').first();
            if (c.length === 1 && c.val().trim().length > 0) {
                newQuery.push("ippodromo=" + encodeURIComponent(c.val()));
            }
            c = thisStatsFilter.find('[name=area]').first();
            if (c.length === 1 && c.val().trim().length > 0) {
                newQuery.push("area=" + encodeURIComponent(c.val()));
            }
            c = thisStatsFilter.find('[name=ordinamento]').first();
            if (c.length === 1 && c.val().trim().length > 0) {
                newQuery.push("ordinamento=" + encodeURIComponent(c.val()));
            }
            c = thisStatsFilter.find('[name=subdisciplina]').first();
            if (c.length === 1 && c.val().trim().length > 0) {
                newQuery.push("subdisciplina=" + encodeURIComponent(c.val()));
            }
            c = thisStatsFilter.find('[name=classe]').first();
            if (c.length === 1 && c.val().trim().length > 0) {
                newQuery.push("classe=" + encodeURIComponent(c.val()));
            }
            c = thisStatsFilter.find('[name=limita]').first();
            if (c.length === 1 && c.val().trim().length > 0) {
                newQuery.push("limita=" + encodeURIComponent(c.val()));
            }

            if (newParams.length > 0) {
                currentURL += newParams.join("/") + "/";
            }
            if (newQuery.length > 0) {
                currentURL += "?" + newQuery.join("&");
            }

            window.location = currentURL;
        };
        var refreshControls = function () {
            var c = thisStatsFilter.find('[name=periodo]').first();
            if (c.length === 1 && c.val().trim() === 'range-date') {
                thisStatsFilter.find('[name=data_inizio]').first().parent().removeClass('d-none');
                thisStatsFilter.find('[name=data_fine]').first().parent().removeClass('d-none');
            } else {

                thisStatsFilter.find('[name=data_inizio]').first().parent().addClass('d-none');
                thisStatsFilter.find('[name=data_fine]').first().parent().addClass('d-none');
            }
        };

        // public API
        return {
            submit: submit,
            refreshControls: refreshControls
        };
    };

    $("form.sportdata-stats-filter").on("submit", function (event) {
        event.preventDefault();
        event.stopPropagation();

        var sportdataStatsFilter = new sportdataStatsFilterClass.run($(this));
        sportdataStatsFilter.submit();
    });

    $("form.sportdata-stats-filter select[name=periodo]").on("change", function (event) {
        var sportdataStatsFilter = new sportdataStatsFilterClass.run($(this));
        sportdataStatsFilter.refreshControls();
    });

    $(window).ready(function () {
        $("form.sportdata-stats-filter").each(function () {
            var sportdataStatsFilter = new sportdataStatsFilterClass.run($(this));
            sportdataStatsFilter.refreshControls();
        });
    });
})(jQuery);
